import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import {
  ICustodyRiskDecompositionEntityDto,
  IGetCexRiskDecompositionResponse,
  IGetLiquidityProviderRiskDecompositionResponse,
  IRisksApi,
} from '@/api/risks/risks.types';

export class RisksApi implements IRisksApi {
  private getBaseUrl(): string {
    return ApiEndpoints.RISKS;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getCexRisksDecomposition() {
    return this.httpClient.get<IGetCexRiskDecompositionResponse>(`${this.getBaseUrl()}exchanges/`);
  }

  getLiquidityProviderRisksDecomposition() {
    return this.httpClient.get<IGetLiquidityProviderRiskDecompositionResponse>(
      `${this.getBaseUrl()}liquidity_providers/`,
    );
  }

  getCustodyRisksDecomposition() {
    return this.httpClient.get<ICustodyRiskDecompositionEntityDto[]>(
      `${this.getBaseUrl()}ccr/historical/`,
    );
  }
}
